import {
  DateCell,
  TableSelectAllCheckbox,
  TableSelectRowCheckbox,
} from '@/components/ui'
import type { ColumnDef } from '@/components/ui/table/types'
import type { Statement } from '@/modules/projects/stores'
import { ContentsCell } from './ContentsCell'
import { DocumentCell } from './DocumentCell'
import { NumberOfPagesCell } from './NumberOfPagesCell'
import { RowActionsCell } from './RowActionsCell'
import { StatusCell } from './StatusCell'

const selectColumn = (): ColumnDef<Statement, any> => ({
  id: 'select',
  header: TableSelectAllCheckbox,
  cell: TableSelectRowCheckbox,
  enableSorting: false,
  enableHiding: false,
  size: 50,
})

const fileNameColumn = (size = 300): ColumnDef<Statement, any> => ({
  accessorKey: 'fileName',
  header: 'Document',
  size,
  meta: { isFluid: true },
  cell: DocumentCell,
})

const createdAtColumn = (): ColumnDef<Statement, any> => ({
  accessorKey: 'createdAt',
  header: 'Uploaded',
  size: 150,
  cell: DateCell,
})

const pagesColumn = (size = 150): ColumnDef<Statement, any> => ({
  accessorKey: 'numberOfPages',
  header: '# of Pages',
  size,
  cell: NumberOfPagesCell,
})

const statusColumn = (size = 130): ColumnDef<Statement, any> => ({
  accessorKey: 'status',
  header: 'Status',
  size,
  cell: StatusCell,
})

const contentsColumn = (size = 340): ColumnDef<Statement, any> => ({
  id: 'contents',
  header: 'Contents',
  size,
  enableSorting: false,
  meta: { wrap: true },
  cell: ContentsCell,
})

const actionsColumn = (): ColumnDef<Statement, any> => ({
  id: 'actions',
  header: '',
  size: 56,
  enableSorting: false,
  enableHiding: false,
  cell: RowActionsCell,
})

export const compactStatementsColumns: ColumnDef<Statement, any>[] = [
  selectColumn(),
  fileNameColumn(150),
  pagesColumn(100),
  statusColumn(130),
]

export const statementColumns: ColumnDef<Statement, any>[] = [
  selectColumn(),
  fileNameColumn(),
  statusColumn(),
  contentsColumn(),
  createdAtColumn(),
  pagesColumn(),
  actionsColumn(),
]
